exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-ugm-active[data-v-50e19908]{background:#252c5f;color:#fff!important;font-weight:600}.btn-ugm-active[data-v-50e19908],.btn-ugm-inactive[data-v-50e19908]{border:2px solid #252c5f;padding:6px 16px;border-radius:4px;cursor:pointer;transition:all .2s}.btn-ugm-inactive[data-v-50e19908]{background:#fff;color:#252c5f!important;font-weight:400}.btn-ugm-inactive[data-v-50e19908]:hover{background:#f0f3ff}", ""]);

// exports
